import React from "react";

const ServiceHeader = ({ className,serviceHeaderImg, serviceHeading, serviceText }) => {
    const words = serviceHeading.split(' ');
    const firstWord = words.shift();
    const remainingWords = words.join(' ');
    return (
        <div className="main"
        data-aos="fade-down"
            data-aos-easing="ease-out-bounce"
            data-aos-delay="300"
            data-aos-duration="2000">
            <div className="service-img-div">
                <img src={serviceHeaderImg} alt="" />
                <h2 className={className}>
                    {firstWord}
                    {remainingWords ? <span className="service-text"> {remainingWords}</span> :  null}
                </h2>
                <p>{serviceText}</p>
            </div>
        </div>
    );
};

export default ServiceHeader;
